import { Theme } from 'styles/theme';

export const getCustomWizardSelectStyles = (theme: Theme) => ({
  menu: (styles: any) => ({
    ...styles,
    boxShadow: 'inset 0 0 0 1px hsla(0, 0%, 0%, 0.1),0 4px 11px hsla(0, 0%, 0%, 0.1)',
    '> div': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  }),
  option: (styles: any, state: any) => ({
    ...styles,
    ...theme.typography.bodyInput,
    color: state.isDisabled ? theme.colors.primaryBlack50 : theme.colors.primaryBlack,
    fontSize: 14,
    fontWeight: state.isSelected ? 600 : 400,
    backgroundColor: state.isSelected
      ? theme.colors.primaryWhite
      : state.isFocused
      ? theme.colors.elementsFilledInput
      : theme.colors.primaryWhite,
    cursor: state.isSelected ? 'default' : 'pointer',
    '&:active': {
      backgroundColor: theme.colors.elementsFilledInput,
    },
  }),
  control: (styles: any, state: any) => ({
    ...styles,
    ...theme.typography.bodyInput,
    minHeight: '44px',
    backgroundColor: state.isDisabled ? theme.colors.elementsFilledInput : theme.colors.primaryWhite,
    boxShadow: 'none',
    borderRadius: '2px',
    borderColor: state.isDisabled
      ? 'transparent'
      : state.isFocused
      ? theme.colors.primaryOrange
      : theme.colors.elementsInputBorder,

    '&:hover': {
      borderColor: theme.colors.primaryOrange,
    },
    '&[aria-disabled]': {
      backgroundColor: theme.colors.elementsFilledInput,
      color: theme.colors.primaryBlack70,
      borderWidth: 0,
    },
  }),
  placeholder: (styles: any, state: any) => ({
    ...styles,
    marginLeft: '0.5rem',
    color: state.isDisabled ? 'transparent' : theme.colors.primaryBlack50,
  }),
  singleValue: (styles: any, state: any) => ({
    ...styles,
    color: state.isDisabled ? theme.colors.primaryBlack70 : theme.colors.black,
    marginLeft: '0.5rem',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
  multiValue: (styles: any) => ({
    ...styles,
    backgroundColor: theme.colors.secondaryLightGreen30,
    borderRadius: '4px',
    '> div': {
      color: theme.colors.primaryGreen,
    },
    '> div:last-child:hover': {
      color: theme.colors.primaryGreen,
      backgroundColor: '#ACC6BC',
    },
    maxWidth: '30rem',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  }),
  multiValueLabel: (styles: any, state: any) => ({
    ...styles,
    fontSize: '100%',
    color: theme.colors.statusLabelGreenText,
    paddingRight: state.isDisabled ? '6px' : '3px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '30rem',
  }),
  multiValueRemove: (styles: any, state: any) => ({
    ...styles,
    display: state.isDisabled ? 'none' : 'flex',
  }),
  indicatorsContainer: (styles: any, state: any) => ({
    ...styles,
    display: state.isDisabled ? 'none' : 'flex',
    '> div': {
      marginRight: 10,
      padding: 0,
    },
  }),
  indicatorSeparator: (styles: any) => ({ ...styles, display: 'none' }),
  dropdownIndicator: (styles: any, state: any) => ({
    ...styles,
    padding: 0,
    width: '16px',
    height: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: state.isDisabled ? theme.colors.primaryBlack50 : theme.colors.primaryBlack,
    svg: {
      width: '16px',
      height: '16px',
    },
    cursor: 'pointer',
    '&:hover': {
      color: theme.colors.primaryOrange,
    },
  }),
  clearIndicator: (styles: any, state: any) => ({
    ...styles,
    padding: 0,
    width: '16px',
    height: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: state.isDisabled ? theme.colors.primaryBlack50 : theme.colors.primaryBlack,
    svg: {
      width: '16px',
      height: '16px',
    },
    cursor: 'pointer',
    '&:hover': {
      color: theme.colors.primaryOrange,
    },
  }),
  input: (styles: any) => ({
    ...styles,
    caretColor: 'transparent',
    color: 'inherit',
  }),
  menuPortal: (base: any) => ({
    ...base,
    zIndex: 999999,
  }),
});
